import React from 'react';

const ADD_LABELS = {
    accordions: 'Add accordion',
    tabs: 'Add tab',
    processLine: 'Add step'
};

/**
 * PageTabs component for GuiBuilder
 * Manages page tab navigation and add/delete page buttons
 */
export default function PageTabs({
    pages,
    activePageIndex,
    setActivePageIndex,
    addPage,
    deletePage,
    flowMode = 'processLine'
}) {
    const allowAddPage = flowMode !== 'allInOne';
    const addLabel = ADD_LABELS[flowMode] || 'Add page';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {flowMode === 'allInOne' && (
                <p style={{ margin: 0, fontSize: '0.75rem', color: 'var(--text-secondary)', lineHeight: 1.4 }}>
                    All in one shows every section on a single configurator page. Additional pages cannot be added.
                </p>
            )}
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid var(--border)', paddingBottom: '0.25rem', gap: '0.5rem', flexWrap: 'wrap' }}>
                {pages.map((p, idx) => (
                    <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                        <button
                            type="button"
                            className={`item-highlight${idx === activePageIndex ? ' is-selected' : ''}`}
                            style={{
                                fontSize: '0.85rem',
                                padding: '0.4rem 1rem',
                                fontWeight: 600
                            }}
                            onClick={() => setActivePageIndex(idx)}
                        >
                            {p.title || `Page ${idx + 1}`}
                        </button>
                        {allowAddPage && (
                            <button
                                type="button"
                                style={{ border: 'none', background: 'transparent', cursor: pages.length <= 1 ? 'not-allowed' : 'pointer', color: 'var(--text-secondary)', fontSize: '0.75rem', padding: '0.2rem' }}
                                onClick={() => deletePage(idx)}
                                title="Delete page"
                                disabled={pages.length <= 1}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        )}
                    </div>
                ))}
                {allowAddPage && (
                    <button
                        type="button"
                        className="btn-secondary"
                        style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem', border: '1px dashed var(--border)' }}
                        onClick={addPage}
                    >
                        <i className="fa-solid fa-plus" style={{ marginRight: '0.25rem' }}></i> {addLabel}
                    </button>
                )}
            </div>
        </div>
    );
}
